exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-height {\n  height: 100%; }\n\n.scroll {\n  overflow: auto; }\n\n.ui.mini.image {\n  height: 2em;\n  width: auto; }\n\n.list-image .list {\n  height: 300px;\n  overflow: auto;\n  background: #767676; }\n\n.list-image .main-image {\n  height: 300px;\n  width: auto; }\n\n.list-image.ui.grid > .column:not(.row) {\n  padding-top: 0px;\n  padding-bottom: 0px; }\n\n.list-image .fourteen.wide.column {\n  background: #767676; }\n\n#map {\n  height: 200px; }\n\n#map img {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -100%);\n          transform: translate(-50%, -100%);\n  z-index: 10000; }\n\n:host .ui.grid {\n  margin: 0px; }\n\nlabel[for] {\n  cursor: pointer; }\n\n.ui.dropdown .menu.active {\n  display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/feedbacks/feedback-edit/feedback-edit.component.scss
// module id = ../../../../../src/app/feedbacks/feedback-edit/feedback-edit.component.scss
// module chunks = main